import { createAction, createReducer } from "@reduxjs/toolkit";

const initialState = {
  reload: undefined,
  searchValue: "",
  norms: [],
  filters: {
    "filters[norm_active]": 1
  },
  pagination: {
    page: 1
  }
};

export const updateCataloguesState = createAction("catalogues/update");

export default createReducer(initialState, (builder) => {
  builder.addCase(updateCataloguesState, (state, { payload = {} }) => {
    return {
      ...state,
      ...payload
    };
  });
});
